export default __webpack_public_path__ + "static/media/oostende-bredene.3b585690.jpg";